import {ResortsConstants} from  './resorts.constants'
const {
    FETCHING_RESORTS,
    FETCHING_RESORTS_SUCCESS,
    FETCHING_RESORTS_FAILURED,
    SETTING_CURRENT_RESORT,
    FETCHING_CITIES,
    FETCHING_CITIES_SUCCESS,
    FETCHING_CITIES_FAILURED,
    FETCHING_ROOMS,
    FETCHING_ROOMS_SUCCESS,
    FETCHING_ROOMS_FAILURED,
    SETTING_CURRENT_PLACE,
    SETTING_CURRENT_ROOM
} = ResortsConstants

const defaultState = {
    resorts:null,
    loading:false,
    error:null,
    currentResort:undefined,
    loadingCities:false,
    placesError:undefined,
    places:undefined,
    loadingRooms:false,
    rooms:null,
    roomsError:undefined,
    currentPlace:undefined,
    currentRoom:undefined

}


const ResortsReducer = (state = defaultState , action) => {
    switch (action.type) {
         // RESORTS
        case FETCHING_RESORTS:
            return{
                ...state,
                loading: true,
        };
        case FETCHING_RESORTS_SUCCESS:
            return{
                ...state,
                loading:false,
                resorts:action.resortsList
        };
        case FETCHING_RESORTS_FAILURED:
            return{
                ...state,
                loading:false,
                error:action.error
        };
         // CURRENT RESORT
        case SETTING_CURRENT_RESORT:
            return{
                ...state,
                currentResort:action.currentResort
        };
        // PLACES
        case FETCHING_CITIES:
            return{
                ...state,
                loadingCities:true
        };
        case FETCHING_CITIES_SUCCESS:
            return{
                ...state,
                loadingCities:false,
                places:action.currentCities
        };
        case FETCHING_CITIES_FAILURED:
            return{
                ...state,
                loadingCities:false,
                placesError:action.error
        };
         // ROOMS
         case FETCHING_ROOMS:
            return{
                ...state,
                loadingRooms:true
        };
        case FETCHING_ROOMS_SUCCESS:
            return{
                ...state,
                loadingRooms:false,
                rooms:action.rooms
        };
        case FETCHING_ROOMS_FAILURED:
            return{
                ...state,
                loadingRooms:false,
                roomsError:action.error
        };
         // CURRENT PLACE
         case SETTING_CURRENT_PLACE:
            return{
                ...state,
                currentPlace:action.place
        };
           // CURRENT ROOM
           case SETTING_CURRENT_ROOM:
            return{
                ...state,
                currentRoom:action.currentRoom,
        };
        default:
        return state;
    }
};

export  default  ResortsReducer;